import React from 'react'

function NotFound() {
    return (
        <div style={{textAlign:"center"}}>
            <h2>404 Route Not Found</h2>
        </div>
    )
}

export default NotFound
